import { Edge, getIncomers, Node } from 'reactflow';
import { TreeNode } from './types';

/**
 * Creates a hierarchy from nodes and edges.
 */
export const hierarchy = (nodes: Node[], edges: Edge[]): TreeNode => {
  const getParentId = (node: Node) => {
    const incomers = getIncomers(node, nodes, edges);

    // If there are no incoming edges, we say this node is connected to the fake
    // root node to prevent having multiple root nodes in the layout. If there
    // are multiple incoming edges, only the first one will be used!
    return incomers[0]?.id;
  };

  const getGeneration = (node: Node, hierarchy: TreeNode) => {
    const parentId = getParentId(node);

    if (!parentId || hierarchy.id === getParentId(node)) {
      return hierarchy;
    }

    if (hierarchy.children) {
      for (const c of hierarchy.children) {
        const generation = getGeneration(node, c);
        if (generation) {
          return generation;
        }
      }
    }
  };

  let hierarchy: TreeNode;

  for (const node of nodes) {
    const n = {
      id: node.id,
      size: { height: node.height ?? 0, width: node.width ?? 0 },
      children: [],
      data: node,
    };

    // The first node in the array is always considered as the root node
    if (!hierarchy) {
      hierarchy = n;

      continue;
    }

    const target = getGeneration(node, hierarchy);

    target.children.push(n);
  }

  return hierarchy;
};
